import BuildYourSolutionComponent from "./build-your-solution";
import * as annoucementSlice from "./build-your-solution.slice";
import * as announcementHelper from "@/common/announcement-helper";
import * as detailSlice from "../../common/components/announcement-detail/detail.slice";
import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
function BuildYourSolution() {
  const dispatch = useDispatch();
  const listRef = useRef(null);

  const announcements = useSelector(annoucementSlice.selectAnnouncements);
  const filters = useSelector(annoucementSlice.selectDetailsFilters);
  const status = useSelector(annoucementSlice.selectStatus);
  const sort = useSelector(annoucementSlice.selecSortFilter);

  useEffect(() => {
    dispatch(detailSlice.clearOffer());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearchClick = () => {
    listRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  let filteredAnnouncements = announcements ? announcements : [];
  if (filters) {
    const { statuses, beneficiaries, outgoings, sectors } = filters;

    if (statuses?.length) {
      filteredAnnouncements = applyStatusesFilter({
        statuses,
        filteredAnnouncements,
      });
    }
    if (beneficiaries?.length) {
      filteredAnnouncements = applyBeneficiariesFilter({
        beneficiaries,
        filteredAnnouncements,
      });
    }
    if (outgoings?.length) {
      filteredAnnouncements = applyOutgoingsFilter({
        outgoings,
        filteredAnnouncements,
      });
    }
    if (sectors?.length) {
      filteredAnnouncements = applySectorsFilter({
        sectors,
        filteredAnnouncements,
      });
    }
  }
  const sortedAnnoucement = filteredAnnouncements
    ? [...filteredAnnouncements]
    : [];
  switch (sort) {
    case annoucementSlice.SORT.STATUS:
      sortedAnnoucement.sort((item1, item2) => {
        const status1 = announcementHelper.getStatus({ announcement: item1 });
        const status2 = announcementHelper.getStatus({ announcement: item2 });
        if (getStatusValue(status1) < getStatusValue(status2)) return -1;
        if (getStatusValue(status1) > getStatusValue(status2)) return 1;
        else return 0;
      });
      break;
    case annoucementSlice.SORT.ASC:
      sortedAnnoucement.sort((item1, item2) => {
        if (item1.closingDate < item2.closingDate) return -1;
        if (item1.closingDate > item2.closingDate) return 1;
        else return 0;
      });
      break;
    case annoucementSlice.SORT.DESC:
      sortedAnnoucement.sort((item1, item2) => {
        if (item1.closingDate < item2.closingDate) return 1;
        if (item1.closingDate > item2.closingDate) return -1;
        else return 0;
      });
      break;
    default:
      break;
  }
  return (
    <BuildYourSolutionComponent
      announcements={sortedAnnoucement}
      status={status}
      listRef={listRef}
      onSearchClick={handleSearchClick}
    />
  );
}

function getStatusValue(status) {
  const map = [
    { name: "In Attivazione", value: 0 },
    { name: "Aperto", value: 1 },
    { name: "In rendicontazione", value: 2 },
    { name: "Chiuso", value: 3 },
  ];
  const value = map.find(({ name }) => name === status)?.value;
  return value;
}

function applyStatusesFilter({ statuses, filteredAnnouncements }) {
  var announcements = filteredAnnouncements.filter((announcement) => {
    const status = announcementHelper.getStatus({ announcement });
    return contains(statuses, status);
  });
  return announcements;
}

function applyBeneficiariesFilter({ beneficiaries, filteredAnnouncements }) {
  var announcements = filteredAnnouncements.filter((announcement) => {
    return announcement.beneficiary.some((r) => beneficiaries.indexOf(r) >= 0);
  });

  return announcements;
}

function applyOutgoingsFilter({ outgoings, filteredAnnouncements }) {
  var announcements = filteredAnnouncements.filter((announcement) => {
    return announcement.outgoings.some((r) => outgoings.indexOf(r) >= 0);
  });

  return announcements;
}

function applySectorsFilter({ sectors, filteredAnnouncements }) {
  var announcements = filteredAnnouncements.filter((announcement) => {
    return sectors.some((r) => announcement.sector.indexOf(r) >= 0);
  });
  return announcements;
}

function contains(list, element) {
  return list.indexOf(element) > -1;
}

export default BuildYourSolution;
